/**
 * Centralised outbound-retailer link builder.
 *
 * Today this returns the raw product URL. When we sign affiliate deals
 * with PB Tech / Harvey Norman / JB Hi-Fi (Commission Factory, Awin, etc),
 * swap the body of `outboundRetailerUrl` to wrap the URL with the affiliate
 * tag and every "Buy now" button on the site picks it up automatically.
 *
 * Tag GA4 outbound clicks so we can measure click-through long before the
 * affiliate switch is live.
 */
const AFFILIATE_PARAMS_BY_RETAILER = {
  // Example future shape:
  // pb_tech: { mode: "querystring", key: "ref", value: "priceguardnz" },
  // jb_hifi: { mode: "wrap", template: "https://aff.example.com/c/123?u={encoded}" },
};

export function outboundRetailerUrl(productUrl, retailerId) {
  if (!productUrl) return null;
  const cfg = AFFILIATE_PARAMS_BY_RETAILER[retailerId];
  if (!cfg) return productUrl;
  try {
    if (cfg.mode === "querystring") {
      const u = new URL(productUrl);
      u.searchParams.set(cfg.key, cfg.value);
      return u.toString();
    }
    if (cfg.mode === "wrap") {
      return cfg.template.replace("{encoded}", encodeURIComponent(productUrl));
    }
  } catch { /* fall through to raw URL */ }
  return productUrl;
}

export function trackBuyNowClick({ retailerId, productUrl, context = "" }) {
  try {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "buy_now_click", {
        retailer_id: retailerId || null,
        product_url: productUrl || null,
        context,
      });
    }
  } catch { /* no-op */ }
}
